// extracted by mini-css-extract-plugin
module.exports = {"button":"OrderDetailLateButton_button__1rhjW","button-ltr":"OrderDetailLateButton_button-ltr__1-T-Y"};